<script setup lang="ts">
import { getCurrentInstance, inject, onBeforeUnmount, computed } from 'vue';
// @ts-expect-error raison: lib externe mal typée
import { defineProps } from 'vue';
import type { CustomStepperContext } from './CustomStepper.vue';

const props = defineProps<{ title: string }>();

const stepper = inject<CustomStepperContext>('customStepper');
if (!stepper) {
    throw new Error('<custom-stepper-step> doit être utilisé à l\'intérieur de <custom-stepper>');
}

const uid = getCurrentInstance()!.uid;

stepper.registerStep({ uid, title: props.title });
onBeforeUnmount(() => stepper.unregisterStep(uid));

const index = computed(() => stepper.steps.value.findIndex((step) => step.uid === uid));
const isActive = computed(() => stepper.activeIndex.value === index.value);
</script>

<template>
    <div v-show="isActive" class="stepper-step-content">
        <slot />
    </div>
</template>
